
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M341.3 277.3c-11.6 0-21.3 14.7-21.3 32s9.8 32 21.3 32c11.6 0 21.3-14.7 21.3-32s-9.7-32-21.3-32zM256 202.7c0-17.3-9.8-32-21.3-32s-21.3 14.7-21.3 32 9.8 32 21.3 32 21.3-14.7 21.3-32z"}}),_c('path',{attrs:{"d":"M501.3 202.7c5.9 0 10.7-4.8 10.7-10.7v-85.3c0-23.6-19.1-42.7-42.7-42.7H42.7C19.1 64 0 83.1 0 106.7V192c0 5.9 4.8 10.7 10.7 10.7 29.4 0 53.3 23.9 53.3 53.3s-23.9 53.3-53.3 53.3C4.8 309.3 0 314.1 0 320v85.3C0 428.9 19.1 448 42.7 448h426.7c23.5 0 42.6-19.1 42.6-42.7V320c0-5.9-4.8-10.7-10.7-10.7-29.4 0-53.3-23.9-53.3-53.3s23.9-53.3 53.3-53.3zm-352 192c0 5.9-4.8 10.7-10.7 10.7-5.9 0-10.7-4.8-10.7-10.7v-21.3c0-5.9 4.8-10.7 10.7-10.7 5.9 0 10.7 4.8 10.7 10.7v21.3zm0-85.4c0 5.9-4.8 10.7-10.7 10.7-5.9 0-10.7-4.8-10.7-10.7V288c0-5.9 4.8-10.7 10.7-10.7 5.9 0 10.7 4.8 10.7 10.7v21.3zm0-85.3c0 5.9-4.8 10.7-10.7 10.7-5.9 0-10.7-4.8-10.7-10.7v-21.3c0-5.9 4.8-10.7 10.7-10.7 5.9 0 10.7 4.8 10.7 10.7V224zm0-85.3c0 5.9-4.8 10.7-10.7 10.7-5.9 0-10.7-4.8-10.7-10.7v-24c0-5.9 4.8-10.7 10.7-10.7 5.9 0 10.7 4.8 10.7 10.7v24zm42.7 64c0-29.4 19.1-53.3 42.7-53.3s42.7 23.9 42.7 53.3-19.2 53.3-42.7 53.3-42.7-23.9-42.7-53.3zm32 160c-2 0-4.1-.6-5.9-1.8-4.9-3.3-6.2-9.9-3-14.8l128-192c3.3-4.9 9.9-6.2 14.8-3 4.9 3.3 6.2 9.9 3 14.8l-128 192c-2.1 3.1-5.5 4.8-8.9 4.8zm117.3 0c-23.5 0-42.7-23.9-42.7-53.3s19.2-53.4 42.7-53.4c23.6 0 42.7 23.9 42.7 53.3s-19.1 53.4-42.7 53.4z"}})])
          )
        }
      }
    